import { t } from "@/i18n-js/instance";
import { MemberCardWithConnection } from "@/react/components/shared/MembersList/CommunityMembers/CardView/MemberCardWithConnection";
import type { useAudienceInfiniteQuery } from "@/react/hooks/useAudienceInfiniteQuery";
import type { CommunityMember } from "@/react/types/CommunityMember";
import { HorizontalListInfiniteScroll } from "../../shared/HorizontalListInfiniteScroll";

type AudienceInfiniteQuery = ReturnType<typeof useAudienceInfiniteQuery>;

interface PendingConnectionsProps {
  pendingConnectionsQuery: AudienceInfiniteQuery;
}

export const PendingConnections = ({
  pendingConnectionsQuery,
}: PendingConnectionsProps) => {
  const pendingConnections = pendingConnectionsQuery.audience || [];
  const hasMorePending = Boolean(pendingConnectionsQuery.hasNextPage);

  if (!pendingConnectionsQuery.isLoading && pendingConnections.length === 0) {
    return null;
  }

  return (
    <HorizontalListInfiniteScroll
      totalCount={pendingConnectionsQuery.totalQueryAudience ?? 0}
      title={t("members_directory.grow.requests")}
      items={pendingConnections}
      hasMore={hasMorePending}
      fetchNextPage={() => pendingConnectionsQuery.fetchNextPage()}
      isFetchingNextPage={Boolean(pendingConnectionsQuery.isFetchingNextPage)}
      isLoading={Boolean(pendingConnectionsQuery.isLoading)}
      containerClassName="mt-6"
      listClassName="mb-6 flex list-none flex-row gap-3 pr-4"
      renderItem={person => (
        <MemberCardWithConnection
          member={person as CommunityMember}
          key={person.id}
        />
      )}
    />
  );
};
